import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { IViewOnlyQuestion } from 'shared-components';

@Injectable({
  providedIn: 'root'
})
export class QuestionTextService {
  private questionTextUpdated$ = new Subject<IViewOnlyQuestion>();

  public updateQuestionText(question: IViewOnlyQuestion): void {
    this.questionTextUpdated$.next(question);
  }

  public questionTextUpdated(): Observable<IViewOnlyQuestion> {
    return this.questionTextUpdated$.asObservable();
  }
}
